import { IQuestionnaire } from 'shared/interfaces/questionnaire.interface';
import { http } from '../utils/axios';

class QuestionnairesService {
  private static instance: QuestionnairesService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): QuestionnairesService {
    if (!QuestionnairesService.instance) {
      QuestionnairesService.instance = new QuestionnairesService();
    }

    return QuestionnairesService.instance;
  }

  public getQuestionnaires = async () => {
    const { data } = await http<IQuestionnaire>({
      url: '/questionnaires',
      method: 'GET'
    });

    return data;
  };
}

const instance = QuestionnairesService.getInstance();

export default instance;
